module.exports = __webpack_public_path__ + "static/img/testimony (38).3713e80b.jpg";